import React, { Component } from 'react';
import Slide from 'react-reveal/Slide';
import Avtar from '../assets/Avtarpic.jpg';
import { IoIosMail, IoLogoGithub, IoIosCall } from 'react-icons/io';
import { MdLocationOn } from 'react-icons/md';

export class Home extends Component {
  render() {
    return (
      <section className='section home' id='home'>
        <div className='info'>
          <Slide left cascade>
            <div className='left'>
              <div className='hello'>Hello I'm</div>
              <h2 className='h2 name'>Avtar Prajapati</h2>
              <h4 className='h4 profession'>Web Developer</h4>
              <ul className='contact'>
                <li className='link'>
                  <IoIosMail className='contact__icon' />
                  <a href='mailto:prajapatiavtar@gmail.com' className='link'>
                    prajapatiavtar@gmail.com
                  </a>
                </li>
                <li className='link'>
                  <IoLogoGithub className='contact__icon' />
                  <a href='https://github.com/avtarprajapati' className='link'>
                    avtarprajapati
                  </a>
                </li>
                <li className='link'>
                  <IoIosCall className='contact__icon' />
                  <a href='tel:+919588221213' className='link'>
                    +91 9588221213
                  </a>
                </li>
                <li className='link'>
                  <MdLocationOn className='contact__icon' />
                  <span>Bhayander East, Mumbai</span>
                </li>
              </ul>
            </div>
          </Slide>
          <Slide right>
            <div className='right'>
              <div className='img-border'>
                <img src={Avtar} alt='Avtar' className='img-pic' />
              </div>
            </div>
          </Slide>
        </div>
      </section>
    );
  }
}

export default Home;
